import React, { Component, Fragment } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { FormControl, FormGroup, HelpBlock, Row } from 'react-bootstrap'
import DatePicker from 'react-datepicker'
import CalendarInput from '../../../directories/components/filters/calendar_input'
import GlgTooltipIcon from '../../../shared/components/glg_tooltip_icon'
import { subMonths, addMonths } from 'date-fns/esm'
import { changeDefaultCourse, getLeaguePotentialCloneCandidate } from '../../actions'
import _ from 'lodash'

import {
  getFromLeaguesOptions,
  getCategoriesOptions,
  getSeasonsOptions,
  checkShowSeasons,
  getToursOptions,
  checkShowTours,
  getDefaultTeesOptions,
  getDefaultCourseOptions,
} from '../../selectors'

import { mapToSelectArray } from 'Shared/helpers'

import {
  GlgPopup,
  GlgPopupForm,
  GlgFormInput,
  GlgSelect,
  GlgRadio,
  GlgCheckbox,
} from 'SharedComponents'

class GeneralCreateLeaguePopup extends Component {
  constructor(props) {
    super(props)
    this.onNameChange = this.onNameChange.bind(this)
    this.onRadioChange = this.onRadioChange.bind(this)
    this.onSelectChange = this.onSelectChange.bind(this)
    this.onCheckBoxChange = this.onCheckBoxChange.bind(this)
    this.onDefaultCourseChange = this.onDefaultCourseChange.bind(this)
    this.state = {
      name: '',
      typedAny: false,
      dcpRoundDateHidden: true,
      roundDate: '',
      eventWithNoTeesheet: false,
      defaultCourseId: '',
      fromSelected: false,
    }
    this.type = 'Event'
    this.showNoTeeSheetOptions = false
    this.holeTypes = [
      {
        value: 1,
        label: 'All 18',
      },
      {
        value: 2,
        label: 'Front 9',
      },
      {
        value: 3,
        label: 'Back 9',
      },
    ]
  }

  shouldComponentUpdate(nextProps, nextState) {
    return this.props.show !== nextProps.show ||
            this.state !== nextState
  }

  validateFrom() {
    return (this.props.type !== 'cloneEvent' || !!this.props.leagueToClone || this.state.fromSelected) ? null : 'error'
  }

  validateName() {
    if (this.state.name.length > 0) {
      return null
    } else {
      return 'error'
    }
  }

  componentDidUpdate(prevProps) {
    if (!prevProps.show) {
      this.setState({dcpRoundDateHidden: true})
    }
  }

  validateRoundDate() {
    if (this.state.dcpRoundDateHidden === true || (this.state.dcpRoundDateHidden === false && this.state.roundDate)) {
      return null
    } else {
      return 'error'
    }
  }

  getLeagueToCloneId() {
    if (this.props.leagueToClone) {
      return this.props.leagueToClone
    } else {
      return null
    }
  }

  getNameValidationState() {
    if (!this.state.typedAny) {
      return null
    } else {
      return this.validateName()
    }
  }

  onNameChange(e) {
    this.setState({
      name: e.target.value,
      typedAny: true,
    })
  }

  onRoundDateChange(date) {
    this.setState({roundDate: date})
  }

  onRadioChange(value) {
    this.type = value.charAt(0).toUpperCase() + value.slice(1)
    if (value === 'dcp') {
      this.setState({dcpRoundDateHidden: false})
    } else {
      this.setState({dcpRoundDateHidden: true})
    }
  }
  onCheckBoxChange(value) {
    this.setState({eventWithNoTeesheet: value})
  }
  onSelectChange(value) {
    this.setState({ ...this.state, fromSelected: true})
    const optionType = this.props.fromLeaguesOptions.filter(option => option.value === value)[0].product
    this.type = optionType.charAt(0).toUpperCase() + optionType.slice(1)

    if (this.props.type === 'cloneEvent') {
      this.props.getLeaguePotentialCloneCandidate(value)
    }
  }
  onDefaultCourseChange(value) {
    this.setState({ ...this.state, defaultCourseId: value})
    this.props.changeDefaultCourse(value)
  }

  handleClose () {
    this.setState({ ...this.state, fromSelected: false })
    this.props.onClose()
  }

  getProductType (source){
    if (this.props.userIsCommunityManager){
      return `community_${source}`
    } else {
      return source
    }
  }

  render() {
    const saveButtonEnabled =
      this.validateName() === null &&
      this.validateRoundDate() === null &&
      this.validateFrom() === null
    const autoFocusName = this.props.type === 'createEvent' || this.props.type === 'quickEvent'

    return (
      <GlgPopup title={ this.props.title }
                saveButtonText={ this.props.saveButtonText }
                saveDisableWith={ !window.I18n ? '' : window.I18n.t('customer_center_menu.components.popups.general_create_league_popup.creating') }
                closeButtonText={ !window.I18n ? '' : window.I18n.t('customer_center_menu.components.popups.general_create_league_popup.cancel') }
                show={ this.props.show }
                onSave={ this.props.onSave }
                formURL={ this.props.formURL }
                onClose={ this.handleClose.bind(this) }
                saveButtonEnabled={ saveButtonEnabled }
                modalClass={ this.props.type === 'createEvent' ? 'create-league-popup' : '' }>
        <GlgPopupForm>
          <FormControl type="hidden" name="customer_id" value={ this.props.customerId } />
          <FormControl type="hidden" name="league[payment_model]" value="golfer-per-round" />
          {this.props.type === 'quickEvent' && (
            <FormControl type="hidden" name="express_event" value="true" />
          )}

          {this.props.type === 'cloneEvent' && (
            <GlgFormInput label={ !window.I18n ? '' : window.I18n.t('customer_center_menu.components.popups.general_create_league_popup.from') }>
              <GlgSelect name="league[from]"
                         items={ this.props.fromLeaguesOptions }
                         searchable={ true }
                         extraInputs={ [
                           { name: 'league[product]', key: 'product' },
                           { name: 'leauge[is_express_event]', key: 'isExpressEvent' },
                         ] }
                         onChange={this.onSelectChange}
                         autoFocus={ (this.getLeagueToCloneId() === null) }
                         noPreFill={ (this.getLeagueToCloneId() === null) }
                         defaultValue={ this.getLeagueToCloneId() }
                         cloneEventSelectLeague={ true }
                         placeholder={ !window.I18n ? '' : window.I18n.t('customer_center_menu.components.popups.general_create_league_popup.search') } />
            </GlgFormInput>
          )}
          <GlgFormInput label={ !window.I18n ? '' : window.I18n.t('customer_center_menu.components.popups.general_create_league_popup.name') }>
            <FormGroup validationState={ this.getNameValidationState() }>
              <FormControl name="league[name]" type="text" value={ this.state.name }
                           onChange={ this.onNameChange }
                           autoFocus={ autoFocusName } />
              <HelpBlock>
                {this.getNameValidationState() !== null &&
                (!window.I18n ? '' : window.I18n.t('customer_center_menu.components.popups.general_create_league_popup.name_must_have_at_least_one_character', {type: this.type}))
                }
              </HelpBlock>
            </FormGroup>
          </GlgFormInput>
          {this.props.type === 'createEvent' && (
            (this.props.customerTripOnly || this.props.userIsCommunityManager) ? (
              <FormControl type="hidden" name="league[product]" value={this.getProductType("trip")} />
            ) : (this.props.customerOnlyEvents ? (
              <FormControl type="hidden" name="league[product]" value="event" />
            ) : (this.props.customerOnlyLeagues ? (
              <FormControl type="hidden" name="league[product]" value="league" />
            ) : (
              <GlgFormInput label={ !window.I18n ? '' : window.I18n.t('customer_center_menu.components.popups.general_create_league_popup.type') }>
                <FormGroup className="add-margin-top-5">
                  <GlgRadio name="league[product]"
                            value="event"
                            label={ !window.I18n ? '' : window.I18n.t('customer_center_menu.components.popups.general_create_league_popup.event') }
                            defaultChecked={ true }
                            onChange={this.onRadioChange} />
                  <GlgRadio name="league[product]"
                            value="league"
                            label={ !window.I18n ? '' : window.I18n.t('customer_center_menu.components.popups.general_create_league_popup.league') }
                            onChange={this.onRadioChange} />
                  {this.props.canCreateNGE && (
                    <GlgRadio name="league[product]"
                              value="non-golf-event"
                              label={ !window.I18n ? '' : window.I18n.t('customer_center_menu.components.popups.general_create_league_popup.non_golf_event') }
                              defaultChecked={ false }
                              onChange={this.onRadioChange} />
                  )}
                  {this.props.canCreateTrips && (
                    <GlgRadio name="league[product]"
                              value="trip"
                              label={ !window.I18n ? '' : window.I18n.t('customer_center_menu.components.popups.general_create_league_popup.trip') }
                              onChange={this.onRadioChange} />
                  )}
                  {this.props.canCreateDCP && (
                    <Fragment>
                      <GlgRadio name="league[product]"
                                value="dcp"
                                label={ !window.I18n ? '' : window.I18n.t('customer_center_menu.components.popups.general_create_league_popup.drive_chip_and_putt') }
                                onChange={this.onRadioChange} />
                      <div className={this.state.dcpRoundDateHidden ? 'hidden' : 'add-margin-top-30'}>
                        <b>
                          Round Date:
                        </b>
                        <FormGroup className="add-margin-top-5">
                          <DatePicker
                            name="round_date"
                            selected={this.state.roundDate}
                            peekNextMonth={true}
                            showMonthDropdown={true}
                            showYearDropdown={true}
                            customInput={<CalendarInput />}
                            minDate={subMonths(new Date(), 120)}
                            maxDate={addMonths(new Date(), 120)}
                            onChange={date => this.onRoundDateChange(date)}
                            dropdownMode={'select'}
                            popperModifiers={{
                              preventOverflow: {
                                enabled: true,
                                escapeWithReference: false, // force popper to stay in viewport (even when input is scrolled out of view)
                                boundariesElement: 'viewport',
                              },
                            }} />
                          <input type="hidden"
                                name="round_date"
                                value={this.state.roundDate} />
                        </FormGroup>
                      </div>
                    </Fragment>
                  )}
                  {((this.type === 'Event' || this.type === 'League') && this.showNoTeeSheetOptions) && (
                    <GlgCheckbox 
                      name="event_with_no_teesheet"
                      value="event_with_no_teesheet"
                      label={ !window.I18n ? '' : window.I18n.t('customer_center_menu.components.popups.general_create_league_popup.the_event_does_not_have_a_tee_sheet', window.participantFormats) }
                      onChange={this.onCheckBoxChange} />
                  )}
                </FormGroup>
              </GlgFormInput>
            ))))
          }
          {this.props.type === 'quickEvent' && (
            <FormControl type="hidden" name="league[product]" value={this.getProductType("event")} />
          )}
          {(this.state.eventWithNoTeesheet && (this.type === 'Event' || this.type === 'League') && this.showNoTeeSheetOptions) && (
            <GlgFormInput label={ !window.I18n ? '' : window.I18n.t('customer_center_menu.components.popups.general_create_league_popup.default_tees') }>
              <FormGroup className="add-margin-top-5">
                <div>
                  Specify the default course
                </div>
                <Row>
                  <div className='col-lg-8 col-md-8 col-sm-8 col-xs-12'>
                    <GlgSelect
                      name="defaultCourse"
                      searchable={ true }
                      items={ this.props.defaultCoursesOptions }
                      onChange={this.onDefaultCourseChange} />
                  </div>
                  <div className='col-lg-4 col-md-4 col-sm-4 col-xs-12 no-padding'>
                    <GlgSelect
                      name="holeType"
                      searchable={ true }
                      items={ this.holeTypes } />
                  </div>
                </Row>
              </FormGroup>
              <FormGroup className="add-margin-top-5">
                <div>
                  { !window.I18n ? '' : window.I18n.t('customer_center_menu.components.popups.general_create_league_popup.specify_default_tee_by_gender') }
                  <GlgTooltipIcon tooltip={ !window.I18n ? '' : window.I18n.t('customer_center_menu.components.popups.general_create_league_popup.you_will_be_able_to_change_tees_on_enter_score_page') } />
                </div>
                <Row className="add-margin-bottom-5">
                  <div className='col-lg-1 col-md-2 col-sm-3 col-xs-4 add-padding-top-10'>
                    <div className='bold'>
                      M
                    </div>
                  </div>
                  <div className='col-lg-11 col-md-10 col-sm-9 col-xs-8 no-padding add-padding-left-10'>
                    <GlgSelect
                      name="defaultTeeM"
                      searchable={ true }
                      items={ this.props.defaultTeesOptions }
                      value={ this.props.defaultTeesOptions[0].label } />
                  </div>
                </Row>
                <Row className="add-margin-bottom-5">
                  <div className='col-lg-1 col-md-2 col-sm-3 col-xs-4 add-padding-top-10'>
                    <div className='bold'>
                      F
                    </div>
                  </div>
                  <div className='col-lg-11 col-md-10 col-sm-9 col-xs-8 no-padding add-padding-left-10'>
                    <GlgSelect
                      name="defaultTeeF"
                      searchable={ true }
                      items={ this.props.defaultTeesOptions }
                      value={ this.props.defaultTeesOptions[0].label } />
                  </div>
                </Row>
              </FormGroup>
            </GlgFormInput>
          )}
          { !this.props.userIsCommunityManager && (
              <GlgFormInput label={!window.I18n ? '' : window.I18n.t('customer_center_menu.components.popups.general_create_league_popup.category')}>
                { this.props.isTmLite ? (
                  <Row>
                    { !window.I18n ? '' : window.I18n.t('customer_center_menu.components.popups.general_create_league_popup.tm_lite_category_message', {type: this.type}) }
                  </Row>
                ) : (
                  <GlgSelect name="category" 
                            searchable={ true } 
                            items={ this.props.categoriesOptions } />
                ) }
              </GlgFormInput>
            )
          }
          {this.props.showTours && (
            <GlgFormInput label={ !window.I18n ? '' : window.I18n.t('customer_center_menu.components.popups.general_create_league_popup.tour') }>
              <GlgSelect name="tour"
                         searchable={ true }
                         items={ this.props.toursOptions } />
            </GlgFormInput>
          )}
          {this.props.userIsCommunityManager ? 
            (<FormControl type="hidden" name="season" value={this.props.currentSeasonId } />)
            :
            (this.props.showSeasons && (
              <GlgFormInput label={ !window.I18n ? '' : window.I18n.t('customer_center_menu.components.popups.general_create_league_popup.season') }>
                <GlgSelect name="season"
                          searchable={ true }
                          items={ this.props.seasonsOptions }
                          defaultValue={ this.props.currentSeasonId } />
              </GlgFormInput>
            ))
        }

        </GlgPopupForm>
      </GlgPopup>
    )
  }
}

GeneralCreateLeaguePopup.propTypes = {
  type: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  saveButtonText: PropTypes.string.isRequired,
  show: PropTypes.bool.isRequired,
  canCreateTrips: PropTypes.bool.isRequired,
  canCreateNGE: PropTypes.bool.isRequired,
  canCreateDCP: PropTypes.bool.isRequired,
  customerTripOnly: PropTypes.bool.isRequired,
  customerOnlyEvents: PropTypes.bool.isRequired,
  customerOnlyLeagues: PropTypes.bool.isRequired,
  formURL: PropTypes.string,
  customerId: PropTypes.string,
  categoriesOptions: PropTypes.array.isRequired,
  defaultTeesMap: PropTypes.any,
  defaultTeesOptions: PropTypes.array.isRequired,
  defaultCoursesOptions: PropTypes.array.isRequired,
  fromLeaguesOptions: PropTypes.array.isRequired,
  seasonsOptions: PropTypes.array.isRequired,
  showSeasons: PropTypes.bool.isRequired,
  currentSeasonId: PropTypes.string,
  toursOptions: PropTypes.array.isRequired,
  showTours: PropTypes.bool.isRequired,
  onSave: PropTypes.func,
  onClose: PropTypes.func.isRequired,
  changeDefaultCourse: PropTypes.func,
  getLeaguePotentialCloneCandidate: PropTypes.func,
  defaultCourseId: PropTypes.string,
  isTmLite: PropTypes.bool,
  leagueToClone: PropTypes.string,
  userIsCommunityManager: PropTypes.bool
}

const mapStateToProps = state => {
  let defaultTees = {}
  if (state.default_tees){
    defaultTees = state.default_tees
  } else if (state.managedCustomerData.default_tees){
    defaultTees = state.managedCustomerData.default_tees
  }
  const defaultTeesMap = defaultTees
  const categoriesOptions = getCategoriesOptions(state, { useManagedCustomer: true })
  const categoriesSelectOptions = mapToSelectArray(categoriesOptions)
  const defaultCoursesOptions = getDefaultCourseOptions(state, { useManagedCustomer: true })
  const defaultCoursesSelectOptions = mapToSelectArray(defaultCoursesOptions)
  const courseId = state.misc.defaultCourseId
  const defaultTeesOptions = getDefaultTeesOptions(defaultTeesMap, courseId)
  const defaultTeesSelectOptions = mapToSelectArray(defaultTeesOptions)
  const fromLeaguesOptions = getFromLeaguesOptions(state)
  const seasonsOptions = getSeasonsOptions(state, { useManagedCustomer: true })
  const currentSeason = seasonsOptions.find(season => season.isCurrent)
  const currentSeasonId = _.get(currentSeason, 'id')
  const seasonsSelectOptions = mapToSelectArray(seasonsOptions)
  const showSeasons = checkShowSeasons(state, { useManagedCustomer: true })
  const isTmLite = state.misc.isTmLite

  const userIsTourManager = state.misc.userIsTourManager
  const toursOptions = getToursOptions(state, { useManagedCustomer: true, addEmptyOption: !userIsTourManager })
  const toursSelectOptions = mapToSelectArray(toursOptions)
  const showTours = checkShowTours(state, { useManagedCustomer: true })

  let canCreateTrips, customerTripOnly, canCreateDCP, canCreateNGE
  if (state.misc.customerId !== state.misc.managedCustomerId) {
    canCreateDCP = !!state.managedCustomerData.canCreateDCP
    canCreateTrips = !!state.managedCustomerData.canCreateTrips
    canCreateNGE = !!state.managedCustomerData.canCreateNGE
    customerTripOnly = !!state.managedCustomerData.customerTripOnly
  } else {
    canCreateDCP = !!state.misc.canCreateDCP
    canCreateTrips = !!state.misc.canCreateTrips
    canCreateNGE = !!state.misc.canCreateNGE
    customerTripOnly = !!state.misc.customerTripOnly
  }

  let canCreateEvents, customerOnlyLeagues
  if (state.misc.customerId !== state.misc.managedCustomerId) {
    canCreateEvents = !!state.managedCustomerData.canCreateEvents
    customerOnlyLeagues = !!state.managedCustomerData.customerOnlyLeagues
  } else {
    canCreateEvents = !!state.misc.canCreateEvents
    customerOnlyLeagues = !!state.misc.customerOnlyLeagues
  }
  return {
    categoriesOptions: categoriesSelectOptions,
    fromLeaguesOptions,
    seasonsOptions: seasonsSelectOptions,
    showSeasons,
    currentSeasonId,
    toursOptions: toursSelectOptions,
    showTours,
    canCreateTrips,
    canCreateNGE,
    canCreateDCP,
    customerTripOnly,
    canCreateEvents,
    customerId: state.misc.managedCustomerId,
    customerOnlyEvents: state.misc.customerOnlyEvents,
    customerOnlyLeagues,
    defaultTeesOptions: defaultTeesSelectOptions,
    defaultCoursesOptions: defaultCoursesSelectOptions,
    defaultCourseId: courseId,
    defaultTeesMap: defaultTeesMap,
    isTmLite,
  }
}

const mapDispatchToProps = dispatch => ({
  changeDefaultCourse: (id) => dispatch(changeDefaultCourse(id)),
  getLeaguePotentialCloneCandidate: (leagueId) => dispatch(getLeaguePotentialCloneCandidate(leagueId)),
})

export default connect(mapStateToProps, mapDispatchToProps)(GeneralCreateLeaguePopup)
